import axios from 'axios';
import router from '../router';
import Vue from 'vue';
import iView from 'iview';
import 'iview/dist/styles/iview.css';

Vue.use(iView);

// axios.defaults.timeout = 5000;
// axios.defaults.baseURL ='http://app.xiaogangbook.com/';//dist
// axios.defaults.baseURL ='/api/';//dist

// axios.defaults.fileURL = process.env.BASE_FILE ;
axios.defaults.baseURL = process.env.API;

//http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token = localStorage.getItem('token');
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type':'application/json;charset=UTF-8'
    };
    // if (token) {
    //   config.headers.token = token;
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code === 401) {
      Vue.prototype.$Message.error('登录超时，请重新登录！');
      router.push({
        name: 'login',
        query: {redirect: router.currentRoute.fullPath}
      })
    } else if(response.data.code === 407){
      Vue.prototype.$Message.error('当前账号已在其他设备登录，请重新登录！');
      router.push({
        name: 'login',
        query: {redirect: router.currentRoute.fullPath}
      })
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.post(url,data)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function del(url,params={}){
  return new Promise((resolve,reject) => {
    axios.delete(url,{
      params:params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/js/request.js